import React from 'react';
import PropTypes, { object, string } from 'prop-types';
import { components } from 'react-select';

import SelectOption from '../SelectOption/SelectOption';

const OptionPart = props => {
  const { data, isMulti, isSelected, selectProps = {} } = props;
  const { capitalize, checkRenderKey, uppercase } = selectProps;

  return (
    <components.Option {...props}>
      <SelectOption
        capitalize={capitalize}
        checkRenderKey={checkRenderKey}
        data={data}
        isMulti={isMulti}
        isSelected={isSelected}
        uppercase={uppercase}
      />
    </components.Option>
  );
};

OptionPart.propTypes = {
  isSelected: PropTypes.bool,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(string),
    PropTypes.arrayOf(object)
  ]),
  data: PropTypes.oneOfType([PropTypes.arrayOf(object), PropTypes.object]),
  isMulti: PropTypes.bool,
  selectProps: PropTypes.object
};

export default OptionPart;
